import React from 'react';
import PropTypes from 'prop-types';
import withStyles from '@material-ui/core/styles/withStyles';
import GraphicEqIcon from '@material-ui/icons/GraphicEq';
import LibraryMusicIcon from '@material-ui/icons/LibraryMusic';
import FavoriteIcon from '@material-ui/icons/Favorite';

import Card from 'components/Card/Card.jsx';
import GridContainer from 'components/Grid/GridContainer.jsx';
import CustomTabs from 'components/CustomTabs/CustomTabs.jsx';
import MessageInfo from 'components/MessageInfo';
import SongCollectionsListItem from 'components/SongCollectionsListItem';
import ActionableSongList from 'components/ActionableSongList.jsx';
import UserImprintSimple from 'components/UserImprintSimple';
import Style from 'assets/jss/material-dashboard-pro-react/views/profileStyle.jsx';

export const TabsForUserTrackProfile = ({
  classes,
  favoriteSongs,
  providerToptracks,
}) => {
  const favorites = [].concat(favoriteSongs, providerToptracks);
  
  return (
  <div>
    <Card
      style={{
        margin: '0px',
        height: '80px',
        borderRadius: '0px',
        backgroundColor: '#FFFFFF',
      }}
      paper='true'
    />
    <Card
      style={{
        padding: '0px 0px 30px 20px',
        borderRadius: '0px',
        boxShadow: 'none',
        margin: '-5px 0px -29px',
        backgroundColor: '#EDEEFB',
        minHeight: '200px',
      }}
      paper='true'
    >
      <CustomTabs
        headerColor='primary'
        tabs={[
          {
            tabName: 'Collections',
            tabIcon: LibraryMusicIcon,
            tabContent: (
              <div style={{ padding: '0px 35px 0px 0px' }}>
                <GridContainer
                  className={classes.mobileAlbum}
                  style={{
                    width: '100%',
                    padding: '0px 0px 0px 3%',
                  }}
                >
                  {[
                    { title: 'Chill Hip-Hop', nb: 26 },
                    { title: 'Festival EDM', nb: 5 },
                    { title: 'Acoustic Music', nb: 26 },
                    { title: 'Folk Tunes', nb: 26 },
                  ].map((e) => (
                    <SongCollectionsListItem key={e.title} data={e} />
                  ))}
                </GridContainer>
              </div>
            ),
          },
          {
            tabName: 'Favorites',
            tabIcon: FavoriteIcon,
            tabContent: (
              <div style={{ padding: '10px 35px 0px 25px' }}>
                <ActionableSongList
                  data={favoriteSongs}
                  listType='favoriteSongs'
                />
              </div>
            ),
          },
          {
            tabName: 'Imprint',
            tabIcon: GraphicEqIcon,
            tabContent: (
              <div style={{ padding: '0px 35px 0px 0px' }}>
                {!favorites.length ? (
                  <MessageInfo text={<div>No data available yet</div>} />
                ) : (
                  <UserImprintSimple
                    favoriteSongs={favorites}
                  />
                )}
              </div>
            ),
          },
        ]}
      />
    </Card>
  </div>
);};

TabsForUserTrackProfile.defaultProps = {
  favoriteSongs: [],
  providerToptracks: [],
};

export default withStyles(Style)(TabsForUserTrackProfile);
